import React, { useState, useEffect } from "react";
import {
    DataGrid,
    GridToolbar,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridColDef,
    GridRowsProp,
    GridToolbarQuickFilter,
    GridValueGetter,
} from "@mui/x-data-grid";
import { Avatar, Chip } from "@mui/material";
import ActionsButton from "../../../components/admin-components/ActionsButton/ActionsButton";

interface User {
    id: string;
    username: string;
    email: string;
    location: {
        city: string;
        province: string;
    };
    status: string;
    lastLogin: string;
    select: boolean;
    actions: string;
    createdAt: string;
    sub?: string;
    role?: string;
    profile?: {
        firstName?: string;
        lastName?: string;
        [key: string]: unknown;
    };
    [key: string]: unknown;
}

const columns: GridColDef[] = [
    // { field: "select", headerName: "Select", width: 80, renderCell: () => <input type="checkbox" /> },
    {
        field: "username",
        headerName: "Username",
        width: 200,
        renderCell: (params: any) => (
            <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                <Avatar>{params.value[0]}</Avatar>
                <span style={{ marginLeft: 8 }}>{params.value}</span>
            </div>
        ),
    },
    {
        field: "email",
        headerName: "Email",
        width: 250,
        renderCell: (params: any) => <a href={`mailto:${params.value}`}>{params.value}</a>,
    },
    {
        field: "location",
        headerName: "Location",
        width: 150,
        renderCell: (params: any) =>
            `${params.row?.location?.city}, ${params.row?.location?.province}`,
        valueGetter: (params: any) => `${params.city}, ${params.province}`,
    },
    {
        field: "status",
        headerName: "Status",
        width: 150,
        renderCell: (params: any) => (
            <Chip
                label={params.value}
                color={
                    params.value === "active"
                        ? "success"
                        : params.value === "pending"
                          ? "default"
                          : "error"
                }
                variant="outlined"
            />
        ),
    },
    { field: "lastLogin", headerName: "Last login", width: 150 },
    {
        field: "actions",
        headerName: "Actions",
        width: 100,
        renderCell: (params: any) => <ActionsButton params={params} />,
    },
];

function CustomToolbar() {
    return (
        <GridToolbarContainer sx={{ display: "flex", gap: 2, p: 2 }}>
            <GridToolbarColumnsButton
                slotProps={{ button: { sx: { "&:hover": { backgroundColor: "#e0e0e0" } } } }}
            />
            <GridToolbarFilterButton
                slotProps={{ button: { sx: { "&:hover": { backgroundColor: "#e0e0e0" } } } }}
            />
            <GridToolbarDensitySelector
                slotProps={{ button: { sx: { "&:hover": { backgroundColor: "#e0e0e0" } } } }}
            />
            <GridToolbarExport
                slotProps={{ button: { sx: { "&:hover": { backgroundColor: "#e0e0e0" } } } }}
            />
            <GridToolbarQuickFilter />
        </GridToolbarContainer>
    );
}

const Accounts: React.FC = () => {
    const [rows, setRows] = useState<GridRowsProp>([
        {
            id: "1",
            username: "John Doe",
            email: "john.doe@example.com",
            location: { city: "New York", province: "NY" },
            status: "active",
            lastLogin: "2024-01-01",
            select: false,
            actions: "...",
            createdAt: "2024-01-01",
        },
        {
            id: "2",
            username: "Jane Doe",
            email: "jane.doe@example.com",
            location: { city: "Los Angeles", province: "CA" },
            status: "pending",
            lastLogin: "2024-01-01",
            select: false,
            actions: "...",
            createdAt: "2024-01-01",
        },
    ]);

    return (
        <div>
            <DataGrid
                rows={rows}
                columns={columns}
                checkboxSelection
                initialState={{
                    density: "comfortable",
                    pagination: {
                        paginationModel: { pageSize: 10, page: 0 },
                    },
                }}
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                classes={{
                    "container--top": "column-headers",
                }}
            />
        </div>
    );
};

export default Accounts;
